import React from 'react'
import { Avatar, AvatarProps, Box } from '@chakra-ui/react'
import { Tooltip } from '@chakra-ui/react'
import { MenuButton } from '@chakra-ui/react'

import { UserBasicInfoFragment } from '~graphql/generated/graphql'
import {
    getAssigneeAvatarSrc,
    getAssigneeDisplayName,
    getAssigneeInitialsBg,
} from './assignee-avatar'

interface Props extends AvatarProps {
    assignee?: UserBasicInfoFragment | null
}

export default function AssigneeButton({
    assignee,
    size = 'sm',
    ...rest
}: Props) {
    const assigneeName = getAssigneeDisplayName(assignee)

    return (
        <Tooltip
            openDelay={300}
            label={
                assignee
                    ? `Assignee: ${assignee.first_name} ${assignee.last_name}`
                    : 'Not assigned'
            }
        >
            <MenuButton
                as={Box}
                display="inline-flex"
                rounded="full"
                cursor="pointer"
                lineHeight={0}
                aria-label="Assignee"
                _focusVisible={{ boxShadow: 'outline' }}
            >
                <Avatar
                    {...rest}
                    size={size}
                    src={getAssigneeAvatarSrc(assignee)}
                    name={assigneeName}
                    bg={getAssigneeInitialsBg(assignee)}
                />
            </MenuButton>
        </Tooltip>
    )
}
